import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-delivery-challan-form',
  templateUrl: './sales-delivery-challan-form.component.html',
  styleUrls: ['./sales-delivery-challan-form.component.css']
})
export class SalesDeliveryChallanFormComponent implements OnInit {
  title="Sales Delivery Challan";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-form/sales-delivery-challan-form.component.ts